import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { AppComponent } from '../app.component';

@Component({
  selector: 'app-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent {
  @Input() titel = 'Gms Replica';
  @Output()
  toggled = new EventEmitter();
  logoUrl: string = '/assets/brw_logo_wit_60.png';

  constructor(public appreference: AppComponent) {}

  public toggleMenu() {
    this.appreference.toggleMenu();
    this.toggled.emit();
  }

  getColor() {
    return '#3f51b5';
  }

  reload() {
    window.location.reload();
  }
}
